export default "__VITE_ASSET__DdBeH4x$__"